import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';
const v = require("voca");
import $ from "jquery";
import { inject, observer } from "mobx-react";
import { MakeForm, makeInput } from "common-import/custom";
import { Request, VarHelper } from "common-import/helpers";

const initialState = {
  message: "",
  keyword: "",
  listCompany: [],
  name: "",
  firstName: "",
  lastName: "",
  email: "",
  companyTaxCode: "",
  phone: "",
  avatar: "",
  position: "",
}

@inject("contactStore", "companyInfoStore") @observer
class ImportContact extends Component {

  state = initialState;

  componentDidMount() {

  }

  createproject = async (projectData) => {
    const { projectStore } = this.props;
    let result = await projectStore.create(projectData);
    if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
    window.toast.info("Tạo nhà thầu thành công");
    setTimeout(() => {
      this.props.history.push("/projects/list-not-approved");
    }, 500);
  }

  renderMutipleImport = () => {
    return (
      <Row>
        <Col xs="12" md="12">
          <Card>
            <CardHeader>
              <i className="fa fa-envelope-open"></i> Create multiple contacts - Upload files (Chưa chạy)
              </CardHeader>
            <CardBody>
              <Form action="" method="post" className="form-horizontal">
                <FormGroup row>
                  <Col md="12">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <Button type="button" color="primary"><i className="fa fa-file"></i> Upload</Button>
                      </InputGroupAddon>
                      <Input type="text" placeholder="File path .xlsx .csv" />
                    </InputGroup>
                  </Col>
                </FormGroup>
              </Form>
              <CardFooter>
                <Button type="submit" size="sm" color="success"><i className="fa fa-dot-circle-o"></i> Submit</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Reset</Button>
              </CardFooter>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    const { keyword, message } = this.state;
    const avatar = this.state.avatar !== "" ? this.state.avatar : "http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg";

    return (
      <div className="animated fadeIn">
        {/* {this.renderMutipleImport()} */}
        <Card>
          <CardHeader>
            <i className="fa fa-envelope-open"></i> Create a contact
          </CardHeader>
          <CardBody>
            <Form onSubmit={this.search}>
              <FormGroup row>
                <Col md="12">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"></i> Search</Button>
                    </InputGroupAddon>
                    {makeInput(this, "keyword")(<Input type="text" placeholder="Nhập tên công ty hoặc mã số thuế để thêm danh sách liên hệ" />)}
                  </InputGroup>
                </Col>
              </FormGroup>
            </Form>
            {message !== "" && <p style={{ marginBottom: 20, testAlign: "center", display: "block", fontWeight: "bold", color: "green" }}>{message}</p>}
            {this.renderCompanyList()}
            <Row>
              <Col xs="12" md="6">
                <Form action="" method="post" onSubmit={this.submitCreateOneUser}>
                  <FormGroup>
                    <Label >Company Tax Code:</Label>
                    {makeInput(this, "companyTaxCode")(<Input type="text" readOnly />)}
                  </FormGroup>
                  <FormGroup>
                    <Label >Display Name:</Label>
                    {makeInput(this, "name")(<Input type="text" />)}
                  </FormGroup>
                  <FormGroup>
                    <Label >First Name:</Label>
                    {makeInput(this, "firstName")(<Input type="text" />)}
                  </FormGroup>
                  <FormGroup>
                    <Label >Last name:</Label>
                    {makeInput(this, "lastName")(<Input type="text" />)}
                  </FormGroup>
                  <FormGroup>
                    <Label >Email:</Label>
                    {makeInput(this, "email")(<Input type="text" />)}
                  </FormGroup>
                  <FormGroup>
                    <Label >Phone:</Label>
                    {makeInput(this, "phone")(<Input type="text" />)}
                  </FormGroup>

                  <FormGroup>
                    <Label >Job title (position):</Label>
                    {makeInput(this, "position")(<Input type="text" />)}
                  </FormGroup>
                </Form>
              </Col>
              <Col xs="12" md="6">
                <FormGroup>
                  <Label>Avatar: </Label>
                  <div style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex"
                  }}>
                    {<img src={avatar} style={{ width: 300, height: 300, borderRadius: "100%", marginBottom: 20 }} />}
                    <input type="file" id={"upload-avatar"} name={"upload-avatar"} style={{ display: "none" }} multiple onChange={this.uploadAvatar} />
                    <label className="btn btn-danger" htmlFor={"upload-avatar"}><i className="fa fa-camera"></i> Upload Images</label>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Button type="submit" size="sm" color="primary" onClick={this.createContact}><i className="fa fa-dot-circle-o"></i> Save</Button>
            <Button type="reset" size="sm" color="danger" onClick={this.clear}><i className="fa fa-ban"></i> Cancel</Button>
          </CardFooter>
        </Card>
      </div>
    );
  }

  renderCompanyList = () => {
    const { listCompany } = this.state
    return (
      <div style={{ maxHeight: 100, overflow: "auto", marginBottom: 20 }}>
        {listCompany.map((val, index) => (
          <p className="cursor hover-underline" key={"comp" + index} onClick={() => this.chooseCompany(val)}>{val.tenChinhThuc}</p>
        ))}
      </div>
    )
  }

  search = async (e) => {
    !!e && e.preventDefault();
    this.setState({ message: "Đang tìm.." });
    const { contactStore, companyInfoStore } = this.props;
    const { keyword } = this.state;
    const isNumber = !isNaN(keyword);
    const findObject = isNumber ? { taxId: keyword } : { name: keyword };
    let companyResult = await companyInfoStore.find(findObject);
    console.log(companyResult);
    if (!!companyResult.error) {
      this.setState({ message: "", companyList: companyResult.data });
      return window.toast.error("Có lỗi xảy ra, vui lòng thử lại " + JSON.stringify(companyResult.error));
    }
    this.setState({ listCompany: companyResult.data, message: companyResult.data.length > 0 ? "" : "Không tìm thấy công ty" })

  }

  chooseCompany = (val) => {
    this.setState({
      listCompany: [],
      message: "Điền form bên dưới để nhập contact cho " + val.tenChinhThuc,
      companyTaxCode: val.maDoanhNghiep
    })
  }

  uploadAvatar = async (e) => {
    const file = e.target.files[0];
    const uploadedUrl = await Request.upload(file);
    this.setState({ avatar: uploadedUrl });
  }

  clear = e => {
    !!e && e.preventDefault();
    this.setState(initialState);
  }

  createContact = async (e) => {
    !!e && e.preventDefault();
    const { contactStore } = this.props;
    const { companyTaxCode, name, firstName, lastName, email, phone, position, avatar } = this.state;
    const newContactObject = VarHelper.filterEmptyObjProp({ companyTaxCode, name, firstName, lastName, email, phone, position, avatar });
    const res = await contactStore.createContact(newContactObject);
    if (!!res.error) {
      return window.toast.error("Có lỗi xảy ra, vui lòng thử lại " + JSON.stringify(res.error));
    }
    window.toast.info("Tạo contact thành công");
    this.clear();
  }

}

export default ImportContact;


// WEBPACK FOOTER //
// ./src/views/Contacts/ImportContact.js